import { translate } from "@/plugins/i18n";
import BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";

export class EnumAccountsPackageType implements BaseEnumType {
  private static allValues: EnumAccountsPackageType[] = []; // make sure this is top-most
  
  public static none = new EnumAccountsPackageType(0, "None", "enum_accounts_package_type_none");
  public static xero = new EnumAccountsPackageType(1, "Xero", "enum_accounts_package_type_xero");
  public static quickBooksLive = new EnumAccountsPackageType(2, "QuickBooksLive", "enum_accounts_package_type_quick_books_live");
  public static quickBooksSandbox = new EnumAccountsPackageType(3, "QuickBooksSandbox", "enum_accounts_package_type_quick_books_sandbox");
  public static sageOne = new EnumAccountsPackageType(4, "SageOne", "enum_accounts_package_type_sage_one");
  public static sage50 = new EnumAccountsPackageType(5, "Sage50", "enum_accounts_package_type_sage50");
  public static sage200 = new EnumAccountsPackageType(6, "Sage200", "enum_accounts_package_type_sage200");
  public static brewmanApi = new EnumAccountsPackageType(7, "BrewmanApi", "enum_accounts_package_type_brewman_api");
  public static customCsv = new EnumAccountsPackageType(8, "CustomCsv", "enum_accounts_package_type_custom_csv");
  public static greenTree = new EnumAccountsPackageType(9, "GreenTree", "enum_accounts_package_type_green_tree");
  public static sage200Web = new EnumAccountsPackageType(10, "Sage200Web", "enum_accounts_package_type_sage200_web");
  public static lexoffice = new EnumAccountsPackageType(11, "Lexoffice", "enum_accounts_package_type_lexoffice");
  public static fortnox = new EnumAccountsPackageType(12, "Fortnox", "enum_accounts_package_type_fortnox");
  public static sageOneZa = new EnumAccountsPackageType(13, "SageOneZa", "enum_accounts_package_type_sage_one_za");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumAccountsPackageType.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isNone() { return this === EnumAccountsPackageType.none; }
  public isXero() { return this === EnumAccountsPackageType.xero; }
  public isQuickBooksLive() { return this === EnumAccountsPackageType.quickBooksLive; }
  public isQuickBooksSandbox() { return this === EnumAccountsPackageType.quickBooksSandbox; }
  public isSageOne() { return this === EnumAccountsPackageType.sageOne; }
  public isSage50() { return this === EnumAccountsPackageType.sage50; }
  public isSage200() { return this === EnumAccountsPackageType.sage200; }
  public isBrewmanApi() { return this === EnumAccountsPackageType.brewmanApi; }
  public isCustomCsv() { return this === EnumAccountsPackageType.customCsv; }
  public isGreenTree() { return this === EnumAccountsPackageType.greenTree; }
  public isSage200Web() { return this === EnumAccountsPackageType.sage200Web; }
  public isLexoffice() { return this === EnumAccountsPackageType.lexoffice; }
  public isFortnox() { return this === EnumAccountsPackageType.fortnox; }
  public isSageOneZa() { return this === EnumAccountsPackageType.sageOneZa; }

  public static getValues(): readonly EnumAccountsPackageType[] {
    return EnumAccountsPackageType.allValues;
  }

  public static getValuesExcept0(): readonly EnumAccountsPackageType[] {
    return EnumAccountsPackageType.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumAccountsPackageType {
    const found = EnumAccountsPackageType.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumAccountsPackageType - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumAccountsPackageType): EnumAccountsPackageType {
    const found = name ? EnumAccountsPackageType.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumAccountsPackageType - Value not found: ${ name }`);
    }

    return found;
  }
}